(() => {
  if (window.__breadcrumbCollectionsHandlerBound) return;
  window.__breadcrumbCollectionsHandlerBound = true;

  const DESKTOP_BREAKPOINT = 990;
  const DESKTOP_TARGET_PATH = "/collections/tum-urunler";

  const isCollectionPath = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      return url.pathname.startsWith("/collections");
    } catch (error) {
      return false;
    }
  };

  const openBurgerMenu = () => {
    const burgerMenu = document.querySelector("burger-menu");

    if (burgerMenu && typeof burgerMenu.open === "function") {
      burgerMenu.open({ preventDefault() {} });
      return true;
    }

    const openButton = document.querySelector(".burger-menu__toggle--open-btn");
    if (openButton) {
      openButton.click();
      return true;
    }

    return false;
  };

  document.addEventListener("click", (event) => {
    const link = event.target.closest(".breadcrumb a[href]");
    if (!link) return;

    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.target === "_blank"
    ) {
      return;
    }

    if (!isCollectionPath(link.href)) return;

    if (window.innerWidth >= DESKTOP_BREAKPOINT) {
      if (!link.pathname.startsWith(DESKTOP_TARGET_PATH)) {
        event.preventDefault();
        window.location.assign(DESKTOP_TARGET_PATH);
      }
      return;
    }

    event.preventDefault();

    if (!openBurgerMenu()) {
      window.location.assign(DESKTOP_TARGET_PATH);
    }
  });
})();
